"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestCatalogMetaFail = exports.requestCatalogMetaSuccess = exports.requestCatalogMeta = void 0;
const typesafe_actions_1 = require("typesafe-actions");
const consts_1 = require("./consts");
exports.requestCatalogMeta = (0, typesafe_actions_1.createAction)(consts_1.REQUEST_CATALOG_META)();
exports.requestCatalogMetaSuccess = (0, typesafe_actions_1.createAction)(consts_1.REQUEST_CATALOG_META_SUCCESS)();
exports.requestCatalogMetaFail = (0, typesafe_actions_1.createAction)(consts_1.REQUEST_CATALOG_META_FAIL)();
